import axios from 'axios';

export const activityTrackApi = axios.create({
  baseURL: process.env.REACT_APP_ACTIVITY_TRACKER_API_URL,
  headers: {
    'Content-Type': 'application/json',
    Authorization: process.env.REACT_APP_ACTIVITY_TRACKER_TOKEN,
  },
});
